import classNames from 'classnames'
import React from 'react'
import CheckIcon from '../../../assets/icons/check.svg'
import CrossIcon from '../../../assets/icons/cross.svg'
import { isNullOrWhiteSpace } from '../../../utilities/string'
import { Paragraph } from '../../Paragraph'

export interface ResultMessageBoxProps {
  messageBody?: string
  messageTitle?: string
  success: boolean
  visible: boolean
}

export const ResultMessageBox = ({
  messageBody,
  messageTitle,
  success,
  visible,
}: ResultMessageBoxProps) => (
  <div
    className={classNames(
      'flex flex-col gap-30 p-45 rounded-15 transition-opacity duration-500',
      {
        'bg-quaternary-lightest': success,
        'bg-neutral': !success,
        'opacity-0 pointer-events-none': !visible,
      }
    )}
  >
    {!isNullOrWhiteSpace(messageTitle) && (
      <h3
        className={classNames('flex items-start gap-15 font-t-bold text-t-600', {
          'text-success': success,
          'text-error': !success,
        })}
      >
        <span
          className={classNames('flex-none p-5 mt-7 rounded-5', {
            'bg-success': success,
            'bg-error': !success,
          })}
        >
          {success ? (
            <CheckIcon className="w-[0.75rem] h-[0.75rem] fill-neutral" />
          ) : (
            <CrossIcon className="w-[0.75rem] h-[0.75rem] fill-neutral" />
          )}
        </span>

        {messageTitle}
      </h3>
    )}

    {!isNullOrWhiteSpace(messageBody) && (
      // Note: Applying leading-body twice for specificity reasons
      <Paragraph
        className={classNames(
          'font-t-light text-t-400 leading-body tracking-body-mobile text-secondary-darkest',
          'tb:text-t-500 tb:leading-body tb:tracking-body-tb'
        )}
      >
        {messageBody}
      </Paragraph>
    )}
  </div>
)
